import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-edit\">\n<path d=\"M90,10c5.5,0,10,4.5,10,10s-4.5,10-10,10H30v140h140v-60l0.1-1.2c0.7-5.5,5.6-9.4,11.1-8.7c5,0.6,8.8,4.9,8.8,9.9v60\n\tc0,11-9,20-20,20H30c-11,0-20-9-20-20V30c0-11,9-20,20-20L90,10z M187.2,12.9c3.9,3.9,3.9,10.2,0,14.1L95.3,119\n\tc-4,3.8-10.3,3.7-14.1-0.2c-3.7-3.9-3.7-10,0-13.9l91.9-91.9C177,9,183.3,9,187.2,12.9L187.2,12.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol